'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-439/overrides/components/product/detail/product-actions.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/571fc3b76b7e").then(m => ({ default: m.ProductActions })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-439/overrides/components/product/detail/product-actions.tsx").ProductActions>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-439/overrides/components/product/detail/product-actions.tsx").ProductActions;
export { Island0 as ProductActions };
